(function(angular) {
    'use strict';

    angular.module('onvio.reports')
        .factory('onvio.reports.employeePortalDocumentsService', employeePortalDocumentsService);

    employeePortalDocumentsService.$inject = ['$http', '$window', 'AuthenticatedSessionData'];

    function employeePortalDocumentsService($http, $window, sessionData) {
        var factory = {
            getCompanyId: getCompanyId,
            getClients: getClients,
            search: search,
            fetchTypes: fetchTypes,
            removeDocuments: removeDocuments
        };

        var baseUrl = '/api/core/v3/companies/';
        var publishedDocumentsBaseUrl = '/api/br-employee-portal/v1/publishedDocuments';
        return factory;

        function getCompanyId() {
            return sessionData.getBindings().then(function(bindings) {
                return bindings.ApplicationConfiguration.CompanyId;
            });
        }

        function getClients(page, search) {
            return getCompanyId().then(function(companyId) {
                return $http({
                    method: 'POST',
                    url: baseUrl + companyId + '/clients/search',
                    data: {
                        expand: 'primaryContactExpanded',
                        filterSearchSort: {
                            orderBy: 'name asc',
                            search: search
                        },
                        pagingDataRequest: {
                            itemsPerPage: 25,
                            pageIndex: page
                        }
                    }
                }).then(function(res) {
                    return res.data;
                });
            });
        }

        function formatId(id) {
            var arr = id.split('');
            arr.splice(8, 0, '-');
            arr.splice(13, 0, '-');
            arr.splice(18, 0, '-');
            arr.splice(23, 0, '-');
            return arr.join('').toLowerCase();
        }

        function formatDate(date) {
            if (!date) {
                return;
            }
            var arr = date.split('/');
            return arr[1] + '-' + arr[0];
        }

        function search(data, page, pageSize, params) {
            var initialBasis, finalBasis;
            var competencyFilter = params.filter.groups[0].items.find(function(item) {
                return item.by === 'competency';
            }) ? params.filter.groups[0].items.find(function(item) {
                return item.by === 'competency';
            }).value : null;

            if (competencyFilter) {
                initialBasis = $window.moment(formatDate(competencyFilter)).format('YYYY-MM-DD');
                finalBasis = formatDate(competencyFilter) + '-' + $window.moment(formatDate(competencyFilter)).daysInMonth();
            }

            return $http({
                method: 'GET',
                url: publishedDocumentsBaseUrl,
                params: {
                    clientId: formatId(data.client),
                    type: data.document,
                    startIndex: (page === 1) ? 0 : (page * pageSize) - pageSize,
                    pageIndex: page,
                    itemsPerPage: pageSize,
                    viewed: data.viewed || data.viewed === false ? data.viewed : null,
                    initialCompetency: !competencyFilter ? (data.initialBasis ? data.initialBasis : null) : initialBasis,
                    finalCompetency: !competencyFilter ? (data.finalBasis ? data.finalBasis : null) : finalBasis,
                    subType: params.filter.groups[0].items.find(function(item) {
                        return item.by === 'type';
                    }) ? params.filter.groups[0].items.find(function(item) {
                        return item.by === 'type';
                    }).value : null,
                    publishedTo: params.filter.groups[0].items.find(function(item) {
                        return item.by === 'publishedTo';
                    }) ? params.filter.groups[0].items.find(function(item) {
                        return item.by === 'publishedTo';
                    }).value : null,
                    publicationDate: params.filter.groups[0].items.find(function(item) {
                        return item.by === 'publicationDate';
                    }) ? params.filter.groups[0].items.find(function(item) {
                        return item.by === 'publicationDate';
                    }).value : null,
                    viewDate: params.filter.groups[0].items.find(function(item) {
                        return item.by === 'viewDate';
                    }) ? params.filter.groups[0].items.find(function(item) {
                        return item.by === 'viewDate';
                    }).value : null
                }
            }).then(function(res) {
                return res.data;
            });
        }

        function fetchTypes(type, lang) {
            return $http({
                method: 'GET',
                url: '/api/br-employee-portal/v1/' + type + '/types?lang=' + lang
            }).then(function(res) {
                return res.data;
            });
        }

        function removeDocuments(type, ids) {
            return $http({
                method: 'DELETE',
                url: publishedDocumentsBaseUrl,
                params: {
                    type: type,
                    ids: ids
                }
            }).then(function(res) {
                return res.data;
            });
        }
    }
})(window.angular);
